import { render, staticRenderFns } from "./PagesCategoryListWidget.vue?vue&type=template&id=922d875c&"
import script from "./PagesCategoryListWidget.vue?vue&type=script&lang=js&"
export * from "./PagesCategoryListWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports